import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getUserDetails } from './features/auth/authSlice';
import Login from './features/auth/components/Login';
import Register from './features/auth/components/Register';
import Chat from './features/chat/components/Chat';
import ProtectedRoute from './components/ProtectedRoute';

const App = () => {
  const dispatch = useDispatch();
  const { userToken, user, isLoading } = useSelector((state) => state.auth);

  useEffect(() => {
    if (userToken && !user) {
      dispatch(getUserDetails());
    }
  }, [userToken, user, dispatch]);

  if (isLoading) {
    return <div>Loading user data...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/login" element={
          userToken ? <Navigate to="/" replace /> : <Login />
        } />
        <Route path="/register" element={
          userToken ? <Navigate to="/" replace /> : <Register />
        } />
        <Route path="/" element={
          <ProtectedRoute>
            <Chat />
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;

